import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CatalogPage from "../pages/catalog/page";
import ProductDetailPage from "../pages/product-detail/page";
import CartPage from "../pages/cart/page";
import CheckoutPage from "../pages/checkout/page";
import OrderSuccessPage from "../pages/order-success/page";
import StoryPage from "../pages/story/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/catalog",
    element: <CatalogPage />,
  },
  {
    path: "/story",
    element: <StoryPage />,
  },
  {
    path: "/product/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/order-success/:orderId",
    element: <OrderSuccessPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;